export default __webpack_public_path__ + "static/media/dropdown-docked-menu.569f12a1.svg";